import { render, staticRenderFns } from "./material-will-receive.vue?vue&type=template&id=3eb24284&scoped=true&"
import script from "./material-will-receive.vue?vue&type=script&lang=js&"
export * from "./material-will-receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb24284",
  null
  
)

export default component.exports